module.exports = __webpack_public_path__ + "static/img/logo.cb6d7ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.jpg
// module id = eOq7
// module chunks = 1